import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import {Objects} from "components";
import {Tooltip} from "@material-ui/core";
export default class ExecutiveCharts extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Executives._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	fetchData = async (state) => {
		const endDate = moment().format('YYYY-MM-DD 23:59:59');
		const startDate = moment().subtract(this.props.filterPeriod.split(' ')[0], this.props.filterPeriod.split(' ')[1]).format('YYYY-MM-DD 00:00:00')
		this.state.filter = {};
		this.state.filter.filterEngineers = this.props.selectedUsers
		this.state.filter.filterDateStart = startDate
		this.state.filter.filterDateEnd = endDate
		this.state.filter.forTable = true;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	render() {
		this.state.data = this.state.data ? this.state.data : [];
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Engineer",
				id: 'user',
				accessor: (obj) => obj.user_data[0].name_first + ' ' + obj.user_data[0].name_last,
			},
			{
				Header: "Total WOs",
				accessor: "total_numbers.work_orders",
			},
			{
				Header: `WOs/${this.props.filterPeriod === "7 days" ? "Day" : "Week"}`,
				id: 'wos_week',
				accessor: (obj) => (obj.total_numbers.work_orders / (this.props.filterPeriod === "7 days" ? 7 : this.props.filterPeriod.split(" ")[0] / 7)).toFixed(2),
			},
			{
				Header: "AVG$/WO",
				id: 'avg_wo',
				accessor: (obj) => (obj.total_numbers.revenue / (obj.total_numbers.work_orders > 0 ? obj.total_numbers.work_orders : 1)).toFixed(2),
			},
			{
				Header: `Revenue/${this.props.filterPeriod === "7 days" ? "Day" : "Week"}`,
				id: 'rev_period',
				accessor: (obj) => (obj.total_numbers.revenue / (this.props.filterPeriod === "7 days" ? 7 : this.props.filterPeriod.split(" ")[0] / 7)).toFixed(2),
			},
			{
				Header: "Total Revenue",
				accessor: "total_numbers.revenue",
			},
			{
				Header: "Total TORs",
				accessor: "total_numbers.total_tors",
			},
			{
				Header: "Approved TORs",
				accessor: "total_numbers.approved_tors",
			},
			{
				Header: "Unapproved TORs",
				accessor: "total_numbers.unapproved_tors",
			},
			{
				Header: "Cancelled TORs",
				accessor: "total_numbers.cancelled_tors",
			},
			{
				Header: "Total Revisits",
				accessor: "total_numbers.revisits",
			},
			{
				Header: `Revisits/${this.props.filterPeriod === "7 days" ? "Day" : "Week"}`,
				id: 'revisits_period',
				accessor: (obj) => (obj.total_numbers.revisits / (this.props.filterPeriod === "7 days" ? 7 : this.props.filterPeriod.split(" ")[0] / 7)).toFixed(2),
			},
			{
				Header: "Total Feedbacks",
				accessor: "total_numbers.feedback",
			},
			{
				Header: "Total Refunds",
				accessor: "total_numbers.refunds",
			},
			{
				Header: "Total $ of Refunds",
				accessor: "total_numbers.refunds_dollar",
			},
		];

		return (
			<div className={'box-body'}>
				<Card>
					<CardContent>
						<div className="table-bar">
							<div className="d-flex">
								{this.renderHeaderRight("ExecutiveTable", columns)}
							</div>
						</div>
						<ReactTable
							key={this.props.filterPeriod + this.props.selectedUsers.length + this.props.forceRefresh + this.props.lastTriggered}
							columns={columns}
							onPageSizeChange={this.onPageSizeChange}
							pageSize={limit}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: 'ranking'
								}
							]}
							showPagination={true}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			</div>
		)
	}
}
